import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Возвращает две заглавные буквы для аватара. По имени из двух слов берёт
 * первые буквы каждого, иначе — первые два символа строки. На пустой/null
 * входе — `'?'`.
 */
export function initials(value: string | null | undefined): string {
  if (!value) return '?';
  const t = value.trim();
  if (!t) return '?';
  const parts = t.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    const a = parts[0]?.[0] ?? '';
    const b = parts[1]?.[0] ?? '';
    const combined = (a + b).toUpperCase();
    if (combined.length > 0) return combined;
  }
  return t.slice(0, 2).toUpperCase();
}
